(function($) {
  'use strict';

  try {
    // sidebar nav toggle
    let mobileSidebarNavTrigger = document.querySelector('.js-mobile-nav-trigger');

    if (mobileSidebarNavTrigger) {

      let targetedNav = mobileSidebarNavTrigger.nextElementSibling;
      let activeMenuText = targetedNav.querySelector('.is-active').textContent;
      mobileSidebarNavTrigger.textContent = activeMenuText; // set button toggle text to current active menu item

      mobileSidebarNavTrigger.addEventListener('click', (e)=> {

        // animate nav down
        $(targetedNav).slideToggle();
        $(mobileSidebarNavTrigger).toggleClass('open');
      })
    }
  }

  catch (err) {
    console.log('There was an error:', err);
  }

})(jQuery);
